import { render, staticRenderFns } from "./RespostaCadastroFrete.vue?vue&type=template&id=36354c76"
import script from "./RespostaCadastroFrete.vue?vue&type=script&lang=js"
export * from "./RespostaCadastroFrete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports